import {cms} from "../services/api";

/**
 * Returns a menu in form of array of `{label: "", anchor: ""}` objects.
 *
 * @example <caption>Response</caption>
 * [
 *  {label: "First element", anchor: "#link"},
 *  {label: "Second element", anchor: "#link2"},
 * ]
 *
 * @param {string} name Name of the menu.
 * @return {Array<{label: string, anchor: string}>|null} array of navigation elements.
 */
export async function getNavigation(name) {
  try {
    const response = await cms.get(`/menus/${name}?nested`);
    if(response.status !== 200) {
      return null;
    }

    const navigation = [];

    const menu = response.data.menu;

    for(const menuItem of menu.items) {
      navigation.push({
                        label:  menuItem.title,
                        anchor: menuItem.url
                      });
    }

    return navigation;
  } catch(error) {
    console.error(error);
  }
}
